import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/Icon';
import styles from '../styles.module.scss';
import { ProgressBar } from './ProgressBar';

export const VolumeControlBar = ({ volumeBarRef, changeVolume }) => {
	const [isActive, setIsActive] = useState(true);
	const [currentVolume, setCurrentVolume] = useState(100);

	const activeStatus = isActive
		? 'audio-volumeButton-active'
		: 'audio-volumeButton-default';

	useEffect(() => {
		volumeBarRef?.current?.style.setProperty(
			'--seek-before-width',
			`${currentVolume}%`
		);
	}, [isActive]);

	useEffect(() => {
		const volume = volumeBarRef.current?.value;
		if (volume || volume === 0) {
			setCurrentVolume(volume);
		}
	}, [volumeBarRef.current?.value]);

	const iconHandleClick = () => {
		setIsActive((prevState) => !prevState);
		changeVolume(isActive ? 0 : currentVolume);
	};

	return (
		<div className={styles.volumeContainer}>
			<button
				type="button"
				className={styles.volumeIconButton}
				onClick={iconHandleClick}
			>
				<Icon icon={activeStatus} />
			</button>
			{isActive && (
				<ProgressBar
					initialValue={currentVolume}
					reference={volumeBarRef}
					onChangeCallback={changeVolume}
				/>
			)}
		</div>
	);
};

VolumeControlBar.propTypes = {
	volumeBarRef: PropTypes.object,
	changeVolume: PropTypes.func.isRequired
};
